import React from "react";

/**
 * Deep Clean — mascot logo. The pelican character with mop and thumbs-up.
 * Image lives at /public/logo.png so it is served statically and works in
 * both the client-rendered app and the prerendered SEO HTML.
 */

export const LogoMark = ({ size = 44, className = "" }) => (
  <img
    src="/logo.png"
    alt=""
    data-testid="logo-mark"
    width={size}
    height={size}
    aria-hidden="true"
    className={`inline-block object-contain ${className}`}
    style={{ width: size, height: size }}
  />
);

export const Logo = ({ size = 48, className = "", testId = "logo", onDark = false }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-3 ${className}`}
  >
    <LogoMark size={size} />
    <span className="flex flex-col leading-none">
      <span
        data-testid="logo-wordmark"
        className={`font-heading text-lg font-extrabold tracking-tight transition-colors ${
          onDark ? "text-white" : "text-slate-900"
        }`}
      >
        Deep Clean<span className={onDark ? "text-cyan-300" : "text-blue-600"}>.</span>
      </span>
      <span
        className={`mt-1.5 font-body text-[9px] font-bold uppercase tracking-[0.32em] transition-colors ${
          onDark ? "text-white/70" : "text-slate-500"
        }`}
      >
        Restroom Services
      </span>
    </span>
  </span>
);

export default Logo;
